import { TState } from '../common/types';
import { Theme } from '@unfold/theme';

export const initialState: TState = {
  authenticated: false,
  loading: false,
  uploading: false,
  theme: Theme.LIGHT,
  loginErrorMessage: ''
};
